
import React from 'react';
import { format } from 'date-fns';
import { Interview } from '@/types/interview';
import { TableCell, TableRow } from '@/components/ui/table';
import TableActionButtons from './TableActionButtons';

interface InterviewTableRowProps {
  interview: Interview;
  onViewInterview: (interview: Interview) => void;
  onEditInterview: (interview: Interview) => void;
  onPublish: (interviewId: string) => void;
  onSendToFeeder: (interviewId: string) => void;
  onDelete: (interviewId: string) => void;
  publishingId: string | null;
  sendingToFeederId: string | null;
  deletingId: string | null;
}

const InterviewTableRow: React.FC<InterviewTableRowProps> = ({
  interview,
  onViewInterview,
  onEditInterview,
  onPublish,
  onSendToFeeder,
  onDelete,
  publishingId,
  sendingToFeederId,
  deletingId
}) => {
  return (
    <TableRow key={interview.id}>
      <TableCell className="font-medium">{interview.intervieweeName}</TableCell>
      <TableCell>
        {format(new Date(interview.timestamp), 'MMM d, yyyy - h:mm a')}
      </TableCell>
      <TableCell>
        <TableActionButtons
          interview={interview}
          onViewInterview={onViewInterview}
          onEditInterview={onEditInterview}
          onPublish={onPublish}
          onSendToFeeder={onSendToFeeder}
          onDelete={onDelete}
          publishingId={publishingId}
          sendingToFeederId={sendingToFeederId}
          deletingId={deletingId}
        />
      </TableCell>
    </TableRow>
  );
};

export default InterviewTableRow;
